import { useDoctorGetPatientsLazyQuery } from "lib/graphql/megaSchema";

export const useGetLoadPatientOptions = () => {
  const [getPatients] = useDoctorGetPatientsLazyQuery();

  const loadPatientOptions = async (name: string) => {
    const { data } = await getPatients({
      variables: { fullText: name, take: 50 },
    });

    if (!data || data.doctorPatients.length === 0) {
      return [];
    }

    return data.doctorPatients.map((patient) => {
      const { id, firstName, lastName, pesel, patientCardNumber, phone } =
        patient;

      const label = `${firstName} ${lastName} / ${patientCardNumber} / ${phone} / ${pesel}`;

      return {
        value: id,
        label,
      };
    });
  };

  return loadPatientOptions;
};
